export const GENERAL_ERROR_MSG = 'Something went wrong. Please refresh the page and try again.';
export const REDIRECT_ERROR_MSG = 'We\'re redirecting you to sign in to your account.';
export const TECHNICAL_ERROR_MSG = 'We\'re sorry. There was a temporary technical error. Please try again later.';